import React, { useState } from 'react';
import { useOtherStyles } from '../../App';
import { LoadingProps, Task, TaskMinimal } from '../../@types';
import { getTasks } from '../../axios/tasks';
import Typography from '@material-ui/core/Typography';
import ItemList from '../../common/List/ItemList';
import Dialog from '@material-ui/core/Dialog';
import CreateTask from './CreateTask';
import SubmitButton from '../../common/Button/SubmitButton';
import AddIcon from '@material-ui/icons/Add';
import IsLoadingHOC from '../../IsLoadingHOC';

export const AllTasks = (props: LoadingProps) => {
	const globalClasses = useOtherStyles();
	const [open, setOpen] = useState(false);
	
	const handleCreateNewItem = () => {
		// history.push(`/investigations/new`);
		setOpen(true)
	};

	const handleClose = () => {
		setOpen(false)
	}

	const [tasks, setTasks] = React.useState<Task[]>([]);
	React.useEffect(() => {
		props.setLoading(true)
		getTasks()
			.then((res: any) => {
				setTasks(res.data);
				props.setLoading(false)
			})
			.catch((err: any) => {
				console.log(err)
				props.setLoading(false)
			});
	}, []);
	
	const handleSearch = () => {
		
	}
    
	return (
		<>
			<Typography variant='h4' className={globalClasses.banner}>
				All Tasks
			</Typography>
			<Typography variant='subtitle2' className={globalClasses.info}>
				All the active tasks on COSINT
			</Typography>

			<hr className={globalClasses.hrDivider} />

			<ItemList name="tasks" items={tasks} />
{/* 
			<SubmitButton
				icon={<AddIcon />}
				message={`Create a new task`}
				onClick={handleCreateNewItem}
				className={globalClasses.createItemButton}
			/>
			<Dialog
				open={open}
				fullWidth
				// className={classes.form}
				keepMounted
				onClose={handleClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<CreateTask />
			</Dialog> */}
		</>
	);
}

export default IsLoadingHOC(AllTasks);
